import React from 'react';
import { useTranslation } from './i18n';
import LandingMarkup from './landing/LandingMarkup';
import { initializeLanding } from './landing/landingRuntime';
import './landing/landing.css';

interface LandingPageV3Props {
  onStart: () => void;
  onTryDemo?: (prompt: string) => void;
}

const LandingPageV3: React.FC<LandingPageV3Props> = ({ onStart }) => {
  const rootRef = React.useRef<HTMLDivElement>(null);
  const startRef = React.useRef(onStart);
  startRef.current = onStart;
  const { t } = useTranslation();
  const title = t('DocumentTitle');

  React.useEffect(() => {
    document.title = title;
    if (!rootRef.current) return;
    return initializeLanding(rootRef.current, () => startRef.current(), title);
  }, [title]);

  return <div ref={rootRef} className="realplc-site realplc-dark-edition premium-minimal"><LandingMarkup /></div>;
};

export default LandingPageV3;
